define('post-editor/math-plugin',['post-editor/sidebar-api', 'tinymce/EditorManager', 'post-editor/MathquillButton'],
function(api, EditorManager, _) {
	// "Edit math" button
	api.defineGroups('img.math', [ {
		title: 'Formel',
		type: 'toolbar',
		items: [
			{
				type: 'button',
				text: 'Bearbeiten',
				cmd: 'wa5_math'
			}
		]
	}]);
	
	// The real math group
	var toolbarButtons = [
		{
			'\\sqrt{x}': 'Quadratwurzel (\\sqrt)',
			'\\sqrt[{n}]{x}': 'n-te Wurzel (\\sqrt[n])',
			'\\frac{a}{b}': 'Bruch (a/b)',
			'\\^{x}': 'Hochstellen (^)',
			'\\_{x}': 'Tiefstellen (_)',
			'\\langle{x}': 'Spize Klammern (\\langle)',
			'\\binom{a}{b}': 'Binom (\\binom)',
		},
		{
			'\\sum': 'Summe (\\sum)',
			'\\prod': 'Produkt (\\prod)',
			'\\int': 'Integral (\\int)',
		},
		{
			'\\cdot': 'Malpunkt (*)',
			'\\pm': 'Plus/Minus (\\pm)',
			'\\mp': 'Minus/Plus (\\mp)',
			'\\pi': 'Pi (\\pi)',
			'\\infty': 'Unendlich (\\infty)',
		},
		{
			'\\ne': 'Ungleich (\\ne)',
			'\\ge': 'Größer oder gleich (\\ge)',
			'\\le': 'Kleiner oder gleich (\\le)',
			'\\asymp': 'Ungefähr gleich (\\asymp)',
		},
		{
			'\\cap': 'Schnitt (\\cap)',
			'\\cup': 'Vereinigung (\\cup)',
			'\\in': 'in Menge (\\in)',
			'\\notin': 'nicht in Menge (\\notin)',
		},
		{
			'\\longrightarrow': 'Pfeil rechts (\\longrightarrow)',
			'\\longleftarrow': 'Pfeil links (\\longleftarrow)',
			'\\Longrightarrow': 'Doppelpfeil rechts (\\Longrightarrow)',
			'\\Longleftarrow': 'Doppelpfeil links (\\Longleftarrow)',
		}
	];
	
	var groups = [];
	toolbarButtons.forEach(function(defs) {
		var buttons = [];
		for (var latex in defs) {
			(function(title, latex) {
				buttons.push({
					type: 'MathquillButton',
					tooltip: title,
					latex: latex,
					onClick: function() {
						EditorManager.activeEditor.execCommand('wa5_math_insert', null, latex);
					}
				});
			})(defs[latex], latex);
		}
		groups.push({
			type: 'buttongroup',
			items: buttons
		});
	});
	
	api.defineGroups('img.math-editor-open', [{
		title: 'Formelsymbole',
		type: 'panel',
		layout: 'flow',
		exclusive: true,
		items: groups
	}]);
});

